import type { ITimeLine } from './TimeLine.h'

import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { TextBoxSC } from 'atoms/TextBox'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const TimeLineSectionSC = styled.div`
  display: block;
  margin: auto 0;

  ${TextBoxSC} {
    padding-left: var(${FIXED_INDENTS.INDENT_40});
  }
`

export const TimeLineSectionWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const TimeLineIndicatorSC = styled.div`
  position: absolute;

  ${TextBoxSC} {
    position: relative;
    padding-left: var(${FIXED_INDENTS.INDENT_30});

    &::after {
      content: '';
      width: 8px;
      height: 8px;
      background: var(${COLOR.ADDITIONAL_RED_2});
      border-radius: 50%;
      position: absolute;
      top: 30%;
      left: 0;
    }
  }
`
export const TimeLineSC = styled.div<
  Pick<ITimeLine, 'backgroundColor'> & {
    valueSection: number
    positionIndicator: number
    sectionWidth: number
    indicatorWidth: number
  }
>`
  --value-section: ${({ valueSection }) => `${valueSection}`};
  --epg-card-width: 86px;

  --timeline-padding-right: 40px;
  --timeline-padding-left: 17px; //16px padding + 1px timesections divider

  ${MEDIA.MIN_1240} {
    --timeline-padding-right: 16px;
    --epg-card-width: 167px;
  }
  position: relative;
  display: flex;
  height: 40px;
  width: 100%;
  background-color: ${({ backgroundColor }) => `var(${backgroundColor})`};
  padding-left: var(--epg-card-width);

  & ${TimeLineSectionSC} {
    width: calc(100% / var(--value-section));
  }

  ${TimeLineIndicatorSC} {
    top: 9px;
    left: ${({ positionIndicator, sectionWidth, indicatorWidth }) =>
      `clamp(calc(var(--epg-card-width) + var(--timeline-padding-left)), calc(var(--epg-card-width) + var(--timeline-padding-left) + ${positionIndicator}px), calc(var(--epg-card-width) + (${sectionWidth}px - ${indicatorWidth}px - var(--timeline-padding-right) )))`};
  }

  ${ButtonSC}:first-child {
    position: absolute;
    top: 0;
    left: 0;
  }

  ${ButtonSC}:last-child {
    position: absolute;
    top: 0;
    right: 0;
  }
`
